module.exports = __webpack_public_path__ + "static/img/sspg_05.8964e8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sspg/sspg_05.jpg
// module id = KCV9
// module chunks = 1